(function (window, $) {
    'use strict';

    function closeAllFitmentTips($scope) {
        ($scope && $scope.length ? $scope : $(document))
            .find('[data-fitment-tip].is-open')
            .removeClass('is-open')
            .attr('aria-expanded', 'false');
    }

    function initFitmentTips($browser) {
        $browser.on('click', '[data-fitment-tip]', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const $btn = $(this);
            const wasOpen = $btn.hasClass('is-open');
            closeAllFitmentTips($browser);
            if (!wasOpen) {
                $btn.addClass('is-open').attr('aria-expanded', 'true');
            }
        });

        $browser.on('keydown', '[data-fitment-tip]', function (e) {
            if (e.key === 'Escape') {
                closeAllFitmentTips($browser);
            }
        });
    }

    function initBrowserRoot($root) {
        if (!$root || !$root.length) {
            return;
        }

        $root.find('.wheel-api-fitment-browser').each(function () {
            const $browser = $(this);
            if ($browser.data('fitment-browser-init')) {
                return;
            }
            $browser.data('fitment-browser-init', true);

            const $search = $browser.find('.wheel-api-fitment-search-input');
            const $noResults = $browser.find('.wheel-api-fitment-no-results');

            function filterFitmentBrowser() {
                const query = ($search.val() || '').toString().trim().toLowerCase();
                let visibleMakes = 0;

                $browser.find('.wheel-api-fitment-make').each(function () {
                    const $make = $(this);
                    const makeName = ($make.data('make') || '').toString().toLowerCase();
                    let visibleModels = 0;

                    $make.find('.wheel-api-fitment-model').each(function () {
                        const $model = $(this);
                        const searchText = ($model.data('search') || '').toString().toLowerCase();
                        const match = query === '' || makeName.indexOf(query) !== -1 || searchText.indexOf(query) !== -1;
                        $model.toggle(match);
                        if (match) {
                            visibleModels++;
                        }
                    });

                    const showMake = query === '' ? true : (makeName.indexOf(query) !== -1 || visibleModels > 0);
                    $make.toggle(showMake);
                    if (showMake) {
                        visibleMakes++;
                        if (query !== '') {
                            $make.prop('open', true);
                        }
                    } else {
                        $make.prop('open', false);
                    }
                });

                $noResults.toggleClass('d-none', visibleMakes > 0);
            }

            $search.on('input', filterFitmentBrowser);
            initFitmentTips($browser);
        });

        if (!$(document).data('fitment-tip-outside-bound')) {
            $(document).data('fitment-tip-outside-bound', true);
            $(document).on('click.fitmentTipOutside', function () {
                closeAllFitmentTips();
            });
        }
    }

    window.CarBuyWheelApiFitmentBrowser = {
        init: initBrowserRoot
    };
})(window, jQuery);
